export default __webpack_public_path__ + "static/images/404eb1bcc68e7d053d4a58a54ce18268.png";